import { Link } from "react-router-dom";
import { Phone, MapPin, Clock, Mail } from "lucide-react";
import { ASSETS, COMPANY, NAV_LINKS } from "@/lib/site";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0E3A1F] text-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <div className="h-14 w-14 rounded-full bg-white p-1 ring-1 ring-white/20 overflow-hidden">
                <img
                  src={ASSETS.logo}
                  alt="Southern Greens Lawn Care logo"
                  className="h-full w-full object-cover rounded-full"
                />
              </div>
              <div>
                <div className="font-display text-xl font-bold">
                  {COMPANY.name}
                </div>
                <div className="text-xs uppercase tracking-widest text-white/70">
                  Lawncare &amp; More
                </div>
              </div>
            </div>
            <p className="mt-6 text-white/80 leading-relaxed max-w-md">
              Hardworking, dependable lawn care for homeowners and businesses
              across {COMPANY.serviceAreaShort}. Honest work, fair prices, and
              yards we’re proud to leave behind.
            </p>
            <Link
              to="/quote"
              data-testid="footer-contact-button"
              className="mt-6 inline-flex items-center gap-2 sg-btn-primary px-6 py-3 rounded-full font-semibold"
            >
              <Mail className="h-4 w-4" /> Contact Us
            </Link>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-display font-semibold text-white mb-4">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-white/75 hover:text-white transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-display font-semibold text-white mb-4">
              Get In Touch
            </h4>
            <ul className="space-y-4 text-white/85">
              <li className="flex items-start gap-3">
                <Phone className="h-5 w-5 mt-0.5 text-[#5BB23B] shrink-0" />
                <a
                  href={COMPANY.telHref}
                  data-testid="footer-call-link"
                  className="font-semibold hover:text-white"
                >
                  {COMPANY.phoneDisplay}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 mt-0.5 text-[#5BB23B] shrink-0" />
                <span>{COMPANY.serviceArea}</span>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="h-5 w-5 mt-0.5 text-[#5BB23B] shrink-0" />
                <span>{COMPANY.hours}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-sm text-white/60">
          <div>
            © {new Date().getFullYear()} {COMPANY.name}. All rights reserved.
          </div>
          <div>Serving {COMPANY.serviceAreaShort} with pride.</div>
        </div>

        <div
          data-testid="footer-credit"
          className="mt-4 pt-3 border-t border-white/10 flex flex-col sm:flex-row items-center justify-center gap-2.5 text-xs text-white/55 text-center"
        >
          <a
            href="#"
            onClick={(e) => e.preventDefault()}
            className="flex items-center gap-2 group"
            aria-label={ASSETS.credit.text}
          >
            <span className="h-7 w-7 rounded-md overflow-hidden ring-1 ring-white/15 bg-black flex items-center justify-center">
              <img
                src={ASSETS.credit.logo}
                alt="Tradesmen Wealth Company logo"
                className="h-full w-full object-cover"
                loading="lazy"
              />
            </span>
            <span className="tracking-wide">
              {ASSETS.credit.text}
            </span>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
